import {
  SprintStatus,
  SprintStatusDisplayOrder,
} from '../../../../../lib/functions/sprint'
import { SPRINT_DEFAULT_COLLAPSED_STATUSES } from '../../../../../domain/entity/SprintEntity'
import { UserBasic } from '../../../../../lib/functions/user'

/** デフォルトで展開するステータス */
export const EXPANDED_STATUSES: SprintStatus[] =
  SprintStatusDisplayOrder.filter(
    status => !SPRINT_DEFAULT_COLLAPSED_STATUSES.includes(status)
  )

/** デフォルトで折りたたむステータス */
export const COLLAPSED_STATUSES: SprintStatus[] =
  SprintStatusDisplayOrder.filter(status =>
    SPRINT_DEFAULT_COLLAPSED_STATUSES.includes(status)
  )

/**
 * ステータスごとにアイテムをグルーピングする
 * status が未設定のアイテムは unsetItems に振り分ける
 */
export const groupByStatus = <T extends { status?: SprintStatus }>(
  items: T[]
): { groups: Map<SprintStatus, T[]>; unsetItems: T[] } => {
  const groups = new Map<SprintStatus, T[]>()
  const unsetItems: T[] = []
  for (const item of items) {
    if (!item.status) {
      unsetItems.push(item)
      continue
    }
    const group = groups.get(item.status)
    if (group) {
      group.push(item)
    } else {
      groups.set(item.status, [item])
    }
  }
  return { groups, unsetItems }
}

export type ViewMode = 'workload' | 'selection'

/** スプリント選択モード用（スプリント単位） */
export interface SprintSelectionItem {
  sprintUuid: string
  sprintName: string
  startDate: string
  endDate: string
  checked: boolean
  status?: SprintStatus
}

/** 工数入力モード用（SPI単位） */
export interface SpiAdjustmentItem {
  /** SPI UUID（新規の場合は仮UUID） */
  uuid: string
  sprintUuid: string
  sprintName: string
  startDate: string
  endDate: string
  estimatedHour: number
  assignee: UserBasic | null
  /** 新規追加かどうか */
  isNew: boolean
}
